import { useRouter } from '@tribeplatform/react-sdk'
import { useNetwork } from '@tribeplatform/react-sdk/hooks'
import { useColorScheme } from '@tribeplatform/react-ui-kit/ThemeProvider'

import { MadeWithBettermodeBadgeDarkSVG } from '../SVG/MadeWithBettermodeBadgeDarkSVG.js'
import { MadeWithBettermodeBadgeSVG } from '../SVG/MadeWithBettermodeBadgeSVG.js'

export const MadeWithBettermode = () => {
  const { data: network } = useNetwork()
  const { colorSchemeMode } = useColorScheme()
  const { Link } = useRouter()

  if (!network.tribeBranding) {
    return null
  }

  return (
    <Link
      href={`https://bettermode.com/?utm_campaign=powered-by&utm_medium=referral&utm_source=${encodeURIComponent(
        network?.domain,
      )}&utm_term=${encodeURIComponent(network?.name)}`}
      target="_blank"
      className="hidden sm:block pointer-events-auto"
    >
      {colorSchemeMode === 'light' && (
        <MadeWithBettermodeBadgeSVG className="w-[177px] shadow bg-white border-branding-line border rounded-md" />
      )}
      {colorSchemeMode === 'dark' && (
        <MadeWithBettermodeBadgeDarkSVG className="w-[177px] shadow bg-black border-branding-line-dark border rounded-md" />
      )}
    </Link>
  )
}
